//
import React, { Component } from 'react';
import { Layout, Menu, Icon } from 'antd';
import nav from './nav.config';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import { getCookie } from './../../hook';

const { Sider, Content } = Layout;
const SubMenu = Menu.SubMenu;

class SidebarTheme extends Component {

    constructor( props ){

        super( props );

        this.state = {
            collapsed           : false,
            defaultSelectedKeys : '/',
            defaultOpenKeys     : '/',
            role                : '' 
        };
        
        this.handleClickSidebar = this.handleClickSidebar.bind( this );
    
    }

    componentWillReceiveProps( nextProps ){
        this.setState({ collapsed: nextProps.onToggle });
    }

    handleClickSidebar( key ){
        if( key.keyPath.length >= 2 ) {
            this.setState({
                defaultSelectedKeys: key.keyPath[0],
                defaultOpenKeys: key.keyPath[1]
            });
        } else {
            this.setState({
                defaultSelectedKeys: key.key,
                defaultOpenKeys: key.key
            });
        }
    }

    componentWillMount(){
        let paths = this.props.path.split( '/' );
        if( paths[2] ){
            this.setState({
                defaultSelectedKeys: '/'+paths[1]+'/'+paths[2],
                defaultOpenKeys: '/'+paths[1]
            });
        } else {
            this.setState({
                defaultSelectedKeys: this.props.path,
                defaultOpenKeys: this.props.path
            });
        }

        const user = getCookie('dv_hrms_user').split(',');

        this.setState({
            role: user[3]
        });

    }

    render() {

        let navs_bar = [];

        if( this.state.role === 'admin' ){
            navs_bar = nav.admin_menu;
        }  else {
            navs_bar = nav.user_menu;
        }
        
        const menu_list = _.map( navs_bar, ( nav_item , i ) => {

            // console.log( nav_item );

            if( nav_item.nav === 'Approvals' ){
                if( this.state.role !== 'manager' && this.state.role !== 'director' && this.state.role !== 'admin' ){
                    return false;
                }
            }
            
            if( nav_item.nav === 'Organization' ){
                if( this.state.role !== 'admin' ){
                    return false;
                }

            } else if( nav_item.nav === 'Settings' ){
                if( this.state.role !== 'admin' ){
                    return false;
                }
                
            } else if( nav_item.nav === 'HR Reports' ){
                if( this.state.role !== 'admin' ){
                    return false;
                }
                
            }

            if( nav_item.sub.length === 1 ){
                return <Menu.Item key={ nav_item.selected } disabled={ nav_item.disabled }>
                            <Link className="route_link" to={ nav_item.selected }>
                            <Icon type={ nav_item.icon } />
                                <span>
                                    { nav_item.nav }
                                </span>
                            </Link>
                    </Menu.Item>
            } else {
                return <SubMenu
                    key={ nav_item.selected }
                    title={ <span><Icon type={ nav_item.icon } /><span>{ nav_item.nav }</span></span> }>
                    {
                        _.map( nav_item.sub, ( sub_nav, j ) => {

                            if( sub_nav.nav === 'Candidate Onboarding' ){
                                if( this.state.role !== 'manager' && this.state.role !== 'director' && this.state.role !== 'admin' ){
                                    return false;
                                }
                            }

                            return <Menu.Item key={ sub_nav.selected } disabled={ sub_nav.disabled }>
                                <Link className="route_link" to={ sub_nav.selected }>
                                    { sub_nav.nav }
                                </Link>
                            </Menu.Item>

                        })

                    }
                </SubMenu>
            }
        });

        return (
            <Sider
                trigger={ null } 
                collapsible 
                collapsed={ this.state.collapsed }>

                <div className="logo dvlogo" />

                <Menu 
                    theme="dark" 
                    mode="vertical" 
                    onClick={ this.handleClickSidebar }
                    defaultSelectedKeys={[ this.state.defaultSelectedKeys ]} >
                    { menu_list }
                </Menu> {/* defaultOpenKeys={[ this.state.defaultOpenKeys ]} */}

            </Sider>
        )
    }
}

export default SidebarTheme


// WEBPACK FOOTER //
// ./src/components/sidebar/index.js